<template>
  <AntConfigProvider :locale="ruRU" :theme="{token: themeAdmin}">
    <RouterView v-if="keycloakAPI.getIsInit.value" />
    <LoadingPage v-else />
  </AntConfigProvider>
</template>

<script setup lang="ts">
import 'dayjs/locale/ru';

import {watch} from 'vue';
import {Grid} from 'ant-design-vue';
import ruRU from 'ant-design-vue/es/locale/ru_RU';
import dayjs from 'dayjs';

import {themeAdmin} from '@/config/theme';

import {keycloakAPI} from '@/assets/keycloak';

import {clientBreakpointState} from '@/services/state/breakpoint';

import antMessage from '@/assets/ant/message';
import AntConfigProvider from '@/assets/ant/config_provider/AntConfigProvider.vue';

import LoadingPage from '@/app/base/pages/LoadingPage.vue';

import {getDetailsFromRequestError} from '@/assets/core/assets/api/doRequest';

dayjs.locale(ruRU.locale);

window.addEventListener('unhandledrejection', function (e) {
  if (e.reason.isUserError)
    antMessage.error(getDetailsFromRequestError(e.reason), 10);
  else antMessage.error(JSON.stringify(e.reason), 10);
});

const breakpointMap = Grid.useBreakpoint();

watch(breakpointMap, (value) => clientBreakpointState.setBreakpointMap(value), {
  immediate: true,
  deep: true,
});
</script>

<style lang="scss">
@import 'assets/styles/defaults';
</style>
